export function filtersToQuery(filters, states = null) {
  let filter_params = {
    sale_price_gteq: String(filters.budget.min_budget).replace(/[^0-9]|\s/g, ''),
    sale_price_lteq: String(filters.budget.max_budget).replace(/[^0-9]|\s/g, ''),
    room_number_gteq: filters.room.min_room_number,
    bedroom_number_gteq: filters.room.min_bedroom_number,
    house_area_or_apartment_area_gteq: filters.surface.min_area,
    house_area_or_apartment_area_lteq: filters.surface.max_area || 100000000
  };

  if (filters.more_criteria) {
    let renovation = [];
    if (filters.more_criteria.includes('hide_ground_floor')) filter_params.floor_not_eq = 0;
    if (filters.more_criteria.includes('with_outsides')) filter_params.terrace_or_balcony_or_garden_eq = true;
    if (filters.more_criteria.includes('with_parking')) filter_params.parking_or_garage_eq = true;
    if (filters.more_criteria.includes('with_elevator')) filter_params.elevator_eq = true;
    if (filters.more_criteria.includes('with_cellar')) filter_params.cellar_eq = true;
    if (filters.more_criteria.includes('with_renovation')) renovation = [...renovation, 'to_renovate'];
    if (filters.more_criteria.includes('without_renovation')) renovation = [...renovation, 'good', 'new'];
    filter_params.good_state_eq_any = renovation;
  }
  filter_params.sale_state_eq_any = handleStates(filters, states);

  // if all dpe checked send empty array to return all properties via ransack even if they have no dpe letter (nil)
  filter_params.dpe_energy_letter_eq_any = filters.dpe.length === 7 ? [''] : filters.dpe;

  let kinds = ['parking_spot'];
  if (filters.type.house === true) kinds = [...kinds, 'house', 'mansion'];
  if (filters.type.apartment === true) kinds = [...kinds, 'apartment', 'duplex', 'triplex', 'loft'];

  filter_params.kind_eq_any = kinds;

  let sortFilterOption = '';
  if (filters.sortFilter === 'salePriceAsc') sortFilterOption = 'sale_price asc';
  if (filters.sortFilter === 'salePriceDesc') sortFilterOption = 'sale_price DESC';
  if (filters.sortFilter === 'salePriceBySurfaceAsc') sortFilterOption = 'house_area_or_apartment_area asc';

  filter_params.s = sortFilterOption;

  const params = { q: filter_params, zones: JSON.stringify(filters.zones) };

  return querifyObject(params);
}

function handleStates(filters, states) {
  let saleStates = [];
  if (states) saleStates = states
  else {
    if (filters.more_criteria.includes('display_for_sale')) saleStates = [...saleStates, 'awaiting_offer', 'awaiting_sale_agreement'];
    if (filters.more_criteria.includes('display_sold')) saleStates = [...saleStates, 'awaiting_notarial_deed', 'sold'];
    if (!filters.more_criteria.includes('display_for_sale') && !filters.more_criteria.includes('display_sold')) saleStates = ['none'];
  }
  return saleStates
}

function toQuery(key, value) {
  return encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

function fullKey(key, parent) {
  if (parent) return parent + '[' + key + ']';
  else return key;
}

function querifyObject(object, parent = null) {
  return Object.keys(object)
    .map((key) => {
      const value = object[key];
      const full_key = fullKey(key, parent);

      if (Array.isArray(value)) return value.map((v) => toQuery(full_key + '[]', v)).join('&');
      else if (typeof value === 'object') return querifyObject(value, full_key);
      else return toQuery(full_key, value);
    })
    .join('&');
}
